<div>
  <form [formGroup]="timeForm">
    <label [for]="button?.button_id">{{ button?.button_label }}</label>
    <p *ngIf="button?.button_sublabel" class="text-muted">
      {{ button?.button_sublabel }}
    </p>
    <div
      class="form-control text-start position-relative"
      [ngClass]="{ 'is-invalid': f.value.errors, 'disapled': button?.button_disable}"
      (click)="timepicker.open()"
    >
      <ng-container *ngIf="timeForm?.get('value')?.value">
        {{
          timeForm?.get("value")?.value
            | date : (timeFormate ? "hh:mm a" : "HH:mm")
        }}
      </ng-container>
      <ng-container *ngIf="!timeForm?.get('value')?.value">
        {{ timeFormate ? "hh:mm a" : "HH:mm" }}
      </ng-container>

      <input
        [matTimepicker]="timepicker"
        type="text"
        id="text-color"
        class="form-control input-lg border-0 position-absolute top-0 start-0 end-0 z"
        formControlName="value"
        (timeChange)="onChange($event)"
        [ngClass]="{ 'is-invalid': f.value.errors }"
        readonly
        style="z-index: -1"
      />
      <mat-timepicker
        #timepicker
        [mode]="timePikermode === '01' ? 'dial' : 'input'"
        color="primary"
        [format]="timeFormate ? '12h' : '24h'"
      >
      </mat-timepicker>
    </div>
    <div *ngIf="f.value.errors" class="invalid-feedback">
      <div *ngIf="f.value.errors.required">
        {{ errorMsgList["required"] }}
      </div>
      <div *ngIf="f.value.errors.minlength">
        {{ errorMsgList["minlength"] }}
      </div>
      <div *ngIf="f.value.errors.maxlength">
        {{ errorMsgList["maxlength"] }}
      </div>
      <div *ngIf="f.value.errors.pattern">
        {{ errorMsgList["pattern"] }}
      </div>
    </div>
  </form>
</div>
